import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DoneIcon from '@mui/icons-material/Done';
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { getGridStringOperators } from "@mui/x-data-grid";
import { useContext, useEffect, useState, useCallback } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import usePermission from "../../hooks/usePermission";
import PermissionGate from "../../components/PermissionGate";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useNavigate } from "react-router-dom";
import Deletepbl from './deletepbl'
import { pblApproveApi } from "../../store/pbl/approvePbl";
import { pblApi } from "../../store/pbl/pblList";
import { ThemeContext } from '../../context/ThemeContext';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";

export default function ManagePbl() {
  const navigate = useNavigate();
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const podcastSelector = useSelector((state) => state?.pblList);
  const pblApprove = useSelector((state) => state?.pblApprove);
  const { result, loading } = podcastSelector;
  const [queryOptions, setQueryOptions] = useState({});
  const [isDownload, setIsDownload] = useState(false)

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const dispatch = useDispatch();
  const { can } = usePermission();

  const columns = [

    {
      field: "title",
      headerName: "Title",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 250,
    },
    {
      field: "pbl_class",
      headerName: "Class",
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: (data) => (<>
        <Typography sx={{ textWrap: "wrap" }}>{Array.isArray(data?.row?.pbl_class) && data?.row?.pbl_class.map((obj, index) => (`${obj['title']}, `))}</Typography>
      </>)
    },
    {
      field: "learning_outcome",
      headerName: "Learning Outcome",
      filterable: false,
      sortable: false,
      width: 200,
    },
    {
      field: "description",
      headerName: "Description",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 200,
    },
    {
      field: "supplies",
      headerName: "Supplies",
      filterable: false,
      sortable: false,
      width: 200,
    },
    {
      field: "reference",
      headerName: "Reference",
      filterable: false,
      sortable: false,
      width: 250,
    },
    {
      field: "subjects",
      headerName: "subjects",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (data) => (<>
        <Typography sx={{ textWrap: "wrap" }}>{Array.isArray(data?.row?.subjects) && data?.row?.subjects.map((obj, index) => (`${obj['title']}, `))}</Typography>
      </>)
    },
    {
      field: "actions",
      headerName: "Actions",
      filterable: false,
      sortable: false,
      width: 500,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="pbl" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available"
              variant="outlined"
              sx={{ margin: "0px 10px" }}
              onClick={() => navigate(`/edit-pbl-management/${row.row.id}`)}
            >
              EDIT
            </Button>
          </PermissionGate>
          <PermissionGate module="pbl" action="delete">
            <Button
              color="error"
              sx={{ margin: "0px 10px" }}
              endIcon={<DeleteIcon />}
              variant="outlined"
              onClick={() => {
                setNotSelectedProductModel(true)
                setDeleteId(row.id)
              }}
            >
              Delete
            </Button>
          </PermissionGate>
          <PermissionGate module="pbl" action="export">
            <Button
              endIcon={<ArrowDownwardIcon />}
              color="error"
              variant="outlined"
              sx={{ margin: "0px 10px" }}
              onClick={() => {
                console.log("row", row)
                window.open(row.row.file)
              }}
            >
              Download
            </Button>
          </PermissionGate>
          <PermissionGate module="pbl" action="moderate">
            <Button
              color="info"
              endIcon={<DoneIcon />}
              sx={{ margin: "0px 10px" }}
              label="Available" variant="outlined"
              onClick={() => addToCartHandler(row.row.id, row.row.is_approved)}
            >
              {row.row.is_approved ? "Disapprove" : "Approve"}
            </Button>
          </PermissionGate>
        </>
      ),
    },



  ];

  const addToCartHandler = async (id, approve) => {
    var obj = {
      project_based_id: id,
      is_approved: !approve,
    }
    await dispatch(
      pblApproveApi(obj)
    );
    if (!pblApprove?.loading) {
      dispatch(
        pblApi(
          {
            page: paginationModel?.page + 1,
            page_size: paginationModel?.pageSize,
          }
        )
      );

    }
  };

  useEffect(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };

    dispatch(pblApi(query));
  }, [dispatch, paginationModel, queryOptions]);

  const addEntry = async () => {
    navigate("/add-pbl-management");
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>

        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Project Based Learning List</Typography>
        </Stack>
        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="pbl" action="create">
              <Button
                onClick={addEntry}
                variant="contained"
              >
                Add New
              </Button>
            </PermissionGate>

          </Stack>
        </Stack>
        <Paper elevation={0}>
          <DataGridComponent
            loading={podcastSelector.loading}
            rowCount={podcastSelector.total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "projectBasedManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, apiUrl: apiRoutes.projectBasedList, permissionModule: "pbl" })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>
      </Body>
      <Deletepbl
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        id={deleteId}
      />
      <BackdropUI open={isDownload} />

    </>
  );
}
